export default class Tracking {
    constructor(app) {
        this.app = app;
        this.prevPageTitle = "";
    }

    // Navigation with hooks in the $Router
    navigation(event, property, pageName, type) {
        let trackingObject = {
            event: event,
            page_location: property, //window.location.href,
            page_referrer: this.prevPageTitle,
            page_title: pageName,
            view_type: type,
        };
        this.CreateLog(trackingObject);

        // remember last page
        this.prevPageTitle = pageName;
    }

    // Explicitly called events with js (buttonclicks etc.)
    event(action, property, payload) {
        let trackingObject = {
            Action: action,
            Property: property,
            ...(payload !== undefined && { Payload: payload }),
        };

        this.CreateLog(trackingObject);
    }

    CreateLog(data) {
        console.log(
            `Tracking => \nevent: ${data.event}\npage_location: ${data.page_location}\npage_referrer: ${data.page_referrer}\npage_title: ${data.page_title}\nview_type: ${data.view_type}`
        );
        dataLayer.push(data);
    }
}

